import { render } from "./QSelectTag.vue?vue&type=template&id=36c34a78"
import script from "./QSelectTag.vue?vue&type=script&lang=js"
export * from "./QSelectTag.vue?vue&type=script&lang=js"

import "./QSelectTag.vue?vue&type=style&index=0&id=36c34a78&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__